import { EhssClient, RequestMethod } from '@/backend/ehss-client'
import { RequestResponseLogic } from '@/logic/ui/request-response'

const RELATIONSHIP_TAG = '/tag'

export const TagLogic = {
    async getTags(params) {
        let result = await EhssClient.sendRequest(RequestMethod.GET, RELATIONSHIP_TAG, params)
        return await RequestResponseLogic.checkRequestResponse(result)
    },
    async createTag(body, params) {
        let result = await EhssClient.sendRequestWithBody(RequestMethod.POST, RELATIONSHIP_TAG, params, body)
        return await RequestResponseLogic.checkRequestResponse(result)
    },
    async setTag(tagId, body, params) {
        let result = await EhssClient.sendRequestWithBody(RequestMethod.PATCH, RELATIONSHIP_TAG + '/' + tagId, params, body)
        return await RequestResponseLogic.checkRequestResponse(result)
    },
    async deleteTag(tagId, params) {
        let result = await EhssClient.sendRequest(RequestMethod.DELETE, RELATIONSHIP_TAG + '/' + tagId, params)
        return await RequestResponseLogic.checkRequestResponse(result)
    }
}